import { render, staticRenderFns } from "./SourceStoreButton.vue?vue&type=template&id=48a27b18&scoped=true&"
import script from "./SourceStoreButton.vue?vue&type=script&lang=js&"
export * from "./SourceStoreButton.vue?vue&type=script&lang=js&"
import style0 from "./SourceStoreButton.vue?vue&type=style&index=0&id=48a27b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a27b18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VImg})
